import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import './styles/index.scss';
import App from './App';
import { store } from './store';
import { installResizeObserverLoopFix } from './shared/utils/resizeObserverLoopFix';

// Must run before anything mounts a ResizeObserver (Chart.js charts, PrimeReact
// DataTables), so every observer created by the app gets the framed version.
installResizeObserverLoopFix();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* PrimeReactProvider initializes the global PrimeReact config object that
        overlay components (Dropdown, Calendar, …) read on document scroll.
        Without it, the scroll listener crashes with "Cannot read properties of
        undefined (reading 'hideOverlaysOnDocumentScrolling')". */}
    <PrimeReactProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </PrimeReactProvider>
  </React.StrictMode>
);
